import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2>Contact Us</h2>
          <p>Get in touch with our caring team</p>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-card">
              <div className="contact-icon">📍</div>
              <h3>Location</h3>
              <p>Regina, Saskatchewan<br />Canada</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">📞</div>
              <h3>Phone</h3>
              <p>(306) 555-0123</p>
              <small>Available 24/7 for emergencies</small>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">✉️</div>
              <h3>Email</h3>
              <p>info@caringhaven.ca</p>
              <small>We respond within 24 hours</small>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">🕒</div>
              <h3>Visit Hours</h3>
              <p>Monday - Sunday<br />9:00 AM - 7:00 PM</p>
              <small>Appointments recommended</small>
            </div>
          </div>
          
          <div className="contact-cta">
            <h3>Ready to Learn More?</h3>
            <p>
              We understand that choosing the right care facility is an important 
              decision. Our team is here to answer all your questions and help 
              you determine if Caring Haven is the right fit for your loved one.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('booking');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="btn-primary"
            >
              Schedule a Visit Today
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;